var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g(_vm._b({staticClass:"menuDivItems",class:{
    menuDivItemsHidden: !_vm.show,
    menuDivItemsHovered: _vm.hovered,
  }},'div',_vm.menuBind,false),_vm.menuOn),[_vm._t("default"),_vm._v(" "),_c('div',{staticClass:"menuDivItemsBorder"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }